import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RxStompConfig } from '@stomp/rx-stomp';
import Aura from '@primeng/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { ENVIRONMENT } from './environment';
import { apiInterceptor, appErrorInterceptor } from './http-interceptors';
import { RX_STOMP_CONFIG, RxStompService, RxStompServiceFactory } from './socket';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiInterceptor, appErrorInterceptor])),
    provideAnimationsAsync(),
    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    })]),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: RX_STOMP_CONFIG,
      useFactory: () => {
        const env = inject(ENVIRONMENT);
        const config: RxStompConfig = {
          brokerURL: env.webSocketUrl,
          heartbeatIncoming: 15000,
          heartbeatOutgoing: 15000,
          discardWebsocketOnCommFailure: true,
        };
        if (!env.production) {
          config.debug = (msg: string): void => {
            console.log(new Date(), msg);
          };
        }
        return config;
      },
    },
    {
      provide: RxStompService,
      useFactory: RxStompServiceFactory,
      deps: [RX_STOMP_CONFIG],
    },
    MessageService,
    ConfirmationService,
  ]
};
